import { useEffect, useMemo, useState } from "react";
import { fetchLocations } from "../../lib/api";
import { SelectField } from "./Field";

export const LocationPicker = ({ prefix, state, district, onChange, stateLabel = "State / UT" }) => {
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    fetchLocations().then(setLocations).catch(() => setLocations([]));
  }, []);

  const stateOptions = useMemo(() => locations.map((s) => ({ value: s.state, label: s.state })), [locations]);
  const districtOptions = useMemo(() => {
    const found = locations.find((s) => s.state === state);
    return found ? found.districts.map((d) => ({ value: d, label: d })) : [];
  }, [locations, state]);

  return (
    <>
      <SelectField
        label={stateLabel}
        value={state}
        onChange={(v) => onChange(v, "")}
        options={stateOptions}
        placeholder={locations.length ? "Select state" : "Loading..."}
        testId={`${prefix}-select-state`}
      />
      <SelectField
        key={state || "none"}
        label="District"
        value={district}
        onChange={(v) => onChange(state, v)}
        options={districtOptions}
        placeholder={state ? `Select district (${districtOptions.length})` : "Select state first"}
        testId={`${prefix}-select-district`}
        disabled={!state}
      />
    </>
  );
};
